import { Navigation } from "@mcleod/core";
import { AutogenLayoutSearchDriverCallinHistory } from "./autogen/AutogenLayoutSearchDriverCallinHistory";
import { ClickEvent, DataSourceExecutionEvent, Label, Panel, Tab, TableRowDisplayEvent } from "@mcleod/components";
import { OrderTabView } from "../OrderTabView";
import { PlanningUtil } from "../planning/PlanningUtil";
import { CommonTooltips } from "@mcleod/common";

export class SearchDriverCallinHistory extends AutogenLayoutSearchDriverCallinHistory {

    override onLoad() {
        this.tabTabSearch.expandCollapseTab(true, false)
        this.styleTab(this.tabTabSearch);
    }

    styleTab(tab: Tab) {
        tab.heading.setProps({ color: "subtle.light", fontBold: false, borderWidth: 0 });
        tab.headingLabel.setProps({ color: "McLeodPrimary", fontSize: "xlarge", fontBold: true });
    }

    buttonClearOnClick(event: ClickEvent) {
        this.clearSearchPanel(this.panelSearch);
        this.buttonClear.enabled = false;
        this.textboxOrder.focus();
    }

    clearSearchPanel(panel: Panel) {
        this.mainDataSource.searchRow.clear();
        this.textboxOrder.clear();
        this.textboxSearchCallinStatus.clear();
        this.textboxSearchEnteredBy.clear();
        this.textboxCallinTime.clear();
        this.textboxTractor.clear();
        this.textboxDriver.clear();
        panel.displayData(this.mainDataSource.searchRow, null, 0);
    }

    sourceDriverCallinHistoryAfterExecution(event: DataSourceExecutionEvent) {
        this.tabTabSearch.expandCollapseTab(false, false);
        this.buttonClear.enabled = true;
    }

    tableDriverCallinHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderIdLabel = tableRow.findComponentById("labelOrderNumber") as Label;
        if (orderIdLabel != null && orderIdLabel.text != "--") {
            orderIdLabel.tooltip = orderIdLabel.text?.startsWith("M") ? "Click to view manifest" : "Click to view order";
            orderIdLabel.applyLinkStyle();
        }
        const labelStopsPickDrop = tableRow.findComponentById("labelStopsPickDrop") as Label;
        if (labelStopsPickDrop) {
            labelStopsPickDrop.applyLinkStyle();
            labelStopsPickDrop.applyButtonHoverStyle();
            CommonTooltips.setTooltipContentLayout(labelStopsPickDrop, null, "lme/dispatch/StopAppointmentStatusList", {
                maxWidth: 800,
                maxHeight: 600
            }, { movement_id: tableRow.data.get("movement_id") });
        }
    }

    orderNumberOnClick(event: ClickEvent) {
        const orderOrManifestId = (event.target as Label)?.text;
        if (orderOrManifestId != "--") {
            if (orderOrManifestId?.startsWith("M")) {
                Navigation.navigateTo("lme/dispatch/OrderList?manifest_id=" + orderOrManifestId, { newTab: true });
            } else {
                OrderTabView.navigateTo({ key: orderOrManifestId, newTab: true });
            }
        }
    }

    multistopOnClick(event: ClickEvent) {
        PlanningUtil.showMultiStopSlideout(event.target as Label, true);
    }

}
